import clsx from "clsx"
import React from "react"
import { IconProps } from "."

export default function MailLine({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M20.1 4.5H3.9C3.6613 4.5 3.43238 4.59482 3.2636 4.7636C3.09482 4.93239 3 5.16131 3 5.4V18.6C3 18.8387 3.09482 19.0676 3.2636 19.2364C3.43238 19.4052 3.6613 19.5 3.9 19.5H20.1C20.3387 19.5 20.5676 19.4052 20.7364 19.2364C20.9052 19.0676 21 18.8387 21 18.6V5.4C21 5.16131 20.9052 4.93239 20.7364 4.7636C20.5676 4.59482 20.3387 4.5 20.1 4.5ZM4.8 8.3142L11.9352 14.7042L19.2 8.2944V17.7H4.8V8.3142ZM18.7401 6.3L11.9451 12.2958L5.2482 6.3H18.7401Z"
        fill="currentColor"
      />
    </svg>
  )
}
